module.exports = __webpack_public_path__ + "img/block-bg.5c9b3231.png";